export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;

export const TIMEOUT_SEC = 10;

export const RES_PER_PAGE = 10;

export const KEY = 'ff437fb6-b8df-4471-ab5a-c663a27abf20';

export const MODAL_CLOSE_SEC = 2.5;
